import { useState } from 'react';
import { Button } from '@heroui/react';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { apiClient } from '@/api/client';
import ItemCategoriesTable from '@/components/settings/ItemCategoriesTable';

export default function SettingsPage() {
  const [isCleaningUp, setIsCleaningUp] = useState(false);

  const handleCleanup = async () => {
    setIsCleaningUp(true);
    try {
      await apiClient.post('/admin/storage/cleanup');
      toast.success('Cleanup started — check server console for results');
    } catch (err: any) {
      toast.error(`Cleanup failed: ${err?.message ?? 'Unknown error'}`);
    } finally {
      setIsCleaningUp(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto py-10 px-6">
      <h1 className="text-lg font-semibold mb-8" style={{ color: 'var(--text-primary)' }}>
        Settings
      </h1>

      <div
        className="rounded-lg border p-5"
        style={{ borderColor: 'var(--border)', backgroundColor: 'var(--bg-surface)' }}
      >
        <h2 className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>
          Storage Cleanup
        </h2>
        <p className="text-xs mb-4" style={{ color: 'var(--text-secondary)' }}>
          Remove orphaned tiles and files from storage that are no longer linked to any record.
          This can happen if the server crashes during a delete operation.
        </p>
        <Button
          size="sm"
          color="danger"
          variant="flat"
          startContent={<Trash2 size={14} />}
          onPress={handleCleanup}
          isLoading={isCleaningUp}
        >
          Clean Up Orphaned Files
        </Button>
      </div>

      <div className="mt-6">
        <ItemCategoriesTable />
      </div>
    </div>
  );
}
